var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDropZoneImageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 51",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M29.166 4.667H12.5A8.333 8.333 0 0 0 4.166 13v25a8.333 8.333 0 0 0 8.334 8.333h25A8.333 8.333 0 0 0 45.833 38V21.333m-6.25-16.666v12.5m6.25-6.25h-12.5m12.5 18.75-6.123-4.409a8.333 8.333 0 0 0-10.444.569l-8.533 7.68a8.333 8.333 0 0 1-10.444.568l-6.122-4.408m18.75-11.459a5.208 5.208 0 1 1-10.417 0 5.208 5.208 0 0 1 10.416 0Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})));
export default SvgDropZoneImageIcon;